module.exports = __webpack_public_path__ + "img/account-recovery.82c8dba9.png";